class VideoPlayer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupVideoContainer();
  }

  setupVideoContainer() {
    const trigger = this.querySelector('.trigger button');
    const videoContainer = this.querySelector('.video-container');
    const videoWrapper = videoContainer?.querySelector('.tw-absolute.tw-inset-0');
    const imageOverlay = this.querySelector('.image');
    const triggerOverlay = this.querySelector('.trigger');

    trigger?.addEventListener('click', () => {
      if (!videoWrapper) return;

      // Get the iframe HTML from the container
      const iframeHTML = videoWrapper.innerHTML;

      // Create a temporary container to parse the iframe
      const tempContainer = document.createElement('div');
      tempContainer.innerHTML = iframeHTML;

      // Get the iframe element
      const iframe = tempContainer.querySelector('iframe');

      if (iframe) {
        // Add necessary styles to the iframe
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.border = '0';

        // Update source URL to autoplay
        let iframeSrc = iframe.src;
        if (iframeSrc.includes('youtube')) {
          iframeSrc = iframeSrc.includes('?') ? `${iframeSrc}&autoplay=1` : `${iframeSrc}?autoplay=1`;
        } else if (iframeSrc.includes('vimeo')) {
          iframeSrc = iframeSrc.includes('?') ? `${iframeSrc}&autoplay=1` : `${iframeSrc}?autoplay=1`;
        }
        iframe.src = iframeSrc;

        // Show video
        videoWrapper.innerHTML = '';
        videoWrapper.appendChild(iframe);

        // Hide overlays
        imageOverlay.classList.add('tw-hidden');
        triggerOverlay.classList.add('tw-hidden');
      }
    });
  }
}

customElements.define('video-player', VideoPlayer);
